import React from 'react';

function CallSection({ attending }) {
  return (
    <div className="call-section">
      {attending.slice(0, 4).map((person, index) => (
        <div key={index} className={`call-box ${index === 0 ? 'highlight' : ''}`}>
          <div className="title-card">{person.module}</div>
          <div className="call-item">{person.name}</div>
        </div>
      ))}
    </div>
  );
}

export default CallSection;
